<template>
  <div class="login-simple-wrapper">
    <div class="login-container">
      <div class="login-card">
        <!-- Logo y título -->
        <div class="text-center mb-4">
          <img
            src="@/assets/images/logo/logo.png"
            alt="Logo"
            class="logo-img"
          />
          <h2 class="login-title">¡Bienvenido a Cortinarte! 👋</h2>
          <p class="login-subtitle">Gestión Comercial de Cortinas para Hoteles</p>
        </div>

        <!-- Formulario de login -->
        <form @submit.prevent="login" class="login-form">
          <div class="form-group">
            <label for="email" class="form-label">Email</label>
            <input
              id="email"
              v-model="form.email"
              type="email"
              class="form-control"
              placeholder="john@example.com"
              required
              autofocus
            />
          </div>

          <div class="form-group">
            <label for="password" class="form-label">Contraseña</label>
            <div class="password-input-wrapper">
              <input
                id="password"
                v-model="form.password"
                :type="showPassword ? 'text' : 'password'"
                class="form-control"
                placeholder="············"
                required
              />
              <button
                type="button"
                class="password-toggle"
                @click="showPassword = !showPassword"
              >
                <i :class="showPassword ? 'feather-eye-off' : 'feather-eye'"></i>
              </button>
            </div>
          </div>

          <div class="form-group">
            <label class="checkbox-label">
              <input
                v-model="form.rememberMe"
                type="checkbox"
                class="form-checkbox"
              />
              <span class="checkmark"></span>
              Recordarme
            </label>
          </div>

          <button
            type="submit"
            class="login-button"
            :disabled="loading"
          >
            <span v-if="loading" class="spinner"></span>
            {{ loading ? 'Iniciando sesión...' : 'Iniciar Sesión' }}
          </button>
        </form>

        <!-- Enlaces adicionales -->
        <div class="login-footer">
          <p class="text-center">
            <span>¿Nuevo en la plataforma?</span>
            <a href="#" class="register-link">Crea una cuenta</a>
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import authService from '@/services/authService'

export default {
  name: 'LoginSimple',
  data() {
    return {
      form: {
        email: '',
        password: '',
        rememberMe: false
      },
      loading: false,
      showPassword: false
    }
  },
  methods: {
    async login() {
      if (!this.form.email || !this.form.password) {
        alert('Por favor, completa todos los campos.')
        return
      }
      
      this.loading = true
      
      try {
        const response = await authService.login({
          email: this.form.email,
          password: this.form.password
        })
        
        console.log('Login exitoso:', response)
        this.loading = false
        
        // Redirigir al dashboard
        window.location.href = '/gestioncomercial/'
      } catch (error) {
        console.error('Error en login:', error)
        this.loading = false
        
        let errorMessage = 'Error al iniciar sesión. '
        if (error.response) {
          if (error.response.status === 403) {
            errorMessage += 'Credenciales incorrectas o usuario no encontrado.'
          } else if (error.response.status === 500) {
            errorMessage += 'Error interno del servidor.'
          } else {
            errorMessage += `Servidor respondió con código ${error.response.status}`
          }
        } else if (error.request) {
          errorMessage += 'No se pudo conectar con el servidor.'
        } else {
          errorMessage += 'Error inesperado.'
        }
        
        alert(errorMessage)
      }
    }
  }
}
</script>

<style scoped>
.login-simple-wrapper {
  min-height: 100vh;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 1rem;
}

.login-container {
  width: 100%;
  max-width: 600px;
}

@media (min-width: 1200px) {
  .login-container {
    max-width: 800px;
  }
}

.login-card {
  background: rgba(255, 255, 255, 0.95);
  border-radius: 20px;
  padding: 2.5rem;
  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.1);
  backdrop-filter: blur(10px);
}

.logo-img {
  max-width: 120px;
  height: auto;
  margin-bottom: 1rem;
}

.login-title {
  color: #2c3e50;
  font-size: 1.75rem;
  font-weight: 700;
  margin-bottom: 0.5rem;
}

.login-subtitle {
  color: #6c757d;
  font-size: 0.95rem;
  margin-bottom: 0;
}

.login-form {
  margin-top: 2rem;
}

.form-group {
  margin-bottom: 1.5rem;
}

.form-label {
  display: block;
  color: #2c3e50;
  font-weight: 600;
  margin-bottom: 0.5rem;
  font-size: 0.9rem;
}

.form-control {
  width: 100%;
  padding: 0.875rem 1rem;
  border: 2px solid #e9ecef;
  border-radius: 10px;
  font-size: 1rem;
  transition: all 0.3s ease;
  background: #fff;
}

.form-control:focus {
  outline: none;
  border-color: #667eea;
  box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.1);
}

.password-input-wrapper {
  position: relative;
}

.password-toggle {
  position: absolute;
  right: 1rem;
  top: 50%;
  transform: translateY(-50%);
  background: none;
  border: none;
  color: #6c757d;
  cursor: pointer;
  padding: 0.5rem;
  border-radius: 5px;
  transition: color 0.3s ease;
}

.password-toggle:hover {
  color: #667eea;
}

.checkbox-label {
  display: flex;
  align-items: center;
  cursor: pointer;
  color: #2c3e50;
  font-size: 0.9rem;
}

.form-checkbox {
  margin-right: 0.75rem;
  width: 18px;
  height: 18px;
  accent-color: #667eea;
}

.login-button {
  width: 100%;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  border: none;
  border-radius: 10px;
  padding: 1rem 2rem;
  font-size: 1rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
}

.login-button:hover:not(:disabled) {
  transform: translateY(-2px);
  box-shadow: 0 10px 25px rgba(102, 126, 234, 0.3);
}

.login-button:disabled {
  opacity: 0.7;
  cursor: not-allowed;
  transform: none;
}

.spinner {
  width: 16px;
  height: 16px;
  border: 2px solid transparent;
  border-top: 2px solid currentColor;
  border-radius: 50%;
  animation: spin 1s linear infinite;
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}

.login-footer {
  margin-top: 2rem;
  padding-top: 1.5rem;
  border-top: 1px solid #e9ecef;
}

.register-link {
  color: #667eea;
  text-decoration: none;
  font-weight: 600;
  margin-left: 0.5rem;
}

.register-link:hover {
  text-decoration: underline;
}

/* Responsive */
@media (max-width: 480px) {
  .login-card {
    padding: 1.5rem;
    margin: 0.5rem;
  }
  
  .login-title {
    font-size: 1.5rem;
  }
  
  .form-control {
    padding: 0.75rem;
  }
  
  .login-button {
    padding: 0.875rem 1.5rem;
  }
}
</style>
